var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-unused-vars */
import { useContext, useMemo } from "react";
import MENU from "./Menu";
import { SidebarContext } from "../../context/SidebarContext";
import { ReactComponent as Closeicon } from "../../icons/leftArrow.svg";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { useQuery } from "react-query";
import getAPIMap from "../../api_map.js";
import ComvivaLogo from "assets/img/comviva-logo.svg";
import { RightArrow } from "../../icons/index.js";
import getIP from "../../getIP.js";
const IP = getIP();
import { useTheme } from "../../context/ThemeContext.js";
import { hexToRgb } from "../../utils/colorHelper";
import { Link } from "react-router-dom";
function SidebarContent() {
    var _a, _b;
    const { closeSidebar, isSidebarOpen } = useContext(SidebarContext);
    const { userDetails, globalConfig, loggedInRole } = useContext(AuthContext);
    const { collapsed, setCollapsed } = useContext(AuthContext);
    const { theme } = useTheme();
    const isDirectoryEnabled = ((_a = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.find((e) => e.key === "isDirectoryEnabled")) === null || _a === void 0 ? void 0 : _a.value) || "true";
    //const [twoLines, setTwoLines] = useState(false);
    let menudata = [];
    let isLineAdded = false;
    const { data, isLoading } = useQuery(["/menu", userDetails], () => __awaiter(this, void 0, void 0, function* () {
        const URL = IP + getAPIMap("menu");
        const config = {
            headers: {
                Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
            },
        };
        return yield axios.get(URL, config);
    }));
    if (!isLoading) {
        menudata = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.data;
    }
    const currentMainMenuName = useMemo(() => {
        var _a;
        let currentMainMenuName = "";
        if (isLoading)
            return currentMainMenuName;
        const menudata = ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.data) || [];
        menudata === null || menudata === void 0 ? void 0 : menudata.forEach((e) => {
            if (e === null || e === void 0 ? void 0 : e.subRoutes) {
                e.subRoutes.forEach((subRoute) => {
                    if (location.pathname.startsWith(subRoute.path)) {
                        currentMainMenuName = e.name;
                    }
                });
            }
            else if (location.pathname.startsWith(e === null || e === void 0 ? void 0 : e.path)) {
                currentMainMenuName = e.name;
            }
        });
        return currentMainMenuName;
    }, [location, isLoading, data]);
    // console.log("menu data is:::::::::: ", menudata);
    return (_jsxs("div", { style: { backgroundColor: theme.sideMenuColor }, className: `transition-all duration-300 ease-in-out h-100vh pb-[28px] flex flex-col fixed top-0 bottom-0 overflow-y-scroll
        ${collapsed ? `w-[70px] ` : `w-[221px]`}`, children: [!isSidebarOpen && (_jsx(Closeicon, { onClick: closeSidebar, className: "h-[20px] w-[20px] fixed top-[15px] ltr:left-[170px] rtl:right-[170px] lg:hidden cursor-pointer" })), _jsx("div", { className: " sticky top-24 ltr:ml-auto rtl:mr-auto w-3 z-40", children: _jsx("button", { className: `w-3 h-4 justify-center flex place-items-center w-[22px] h-[22px] rounded-full fixed top-[72px] transition-transform duration-300 ease-in-out transform ${!collapsed ? "rotate-180" : ""}`, style: {
                        backgroundColor: theme.tertiaryColor,
                        boxShadow: "0px 0px 4px #0000004D",
                        backgroundColor: theme.tertiaryColor,
                    }, onClick: () => {
                        setCollapsed(!collapsed);
                    }, children: _jsx(RightArrow, { className: "h-2 w-2", style: { color: "white" } }) }) }), _jsxs("div", { className: "top-0 sticky mb-6", style: { backgroundColor: theme.sideMenuColor }, children: [_jsx("div", { style: { minHeight: 64 }, className: "flex items-center  justify-center", children: _jsx(Link, { to: "/app/home", className: `transition-all duration-300 ease-in-out flex justify-center  w-full ${collapsed ? "px-4" : "mx-4"}`, children: collapsed ? (_jsx("img", { className: "h-full w-auto", src: theme.faviconUrl ? theme.faviconUrl : ComvivaLogo, alt: "Favicon" }, 1)) : (_jsx("img", { className: " h-full w-auto mx-0", src: theme.logos ? theme.logos : ComvivaLogo, alt: "Logo" }, 2)) }) }), _jsx("div", { className: "px-6", children: _jsx("hr", { style: {
                                borderTop: `1px solid rgba(${hexToRgb(theme === null || theme === void 0 ? void 0 : theme.menuTextColor)}, 0.2)`,
                            } }) })] }), menudata === null || menudata === void 0 ? void 0 : menudata.map((route, i) => {
                if (route.name) {
                    isLineAdded = false;
                    return (_jsx(MENU, { route: route, isExpanded: route.name == currentMainMenuName }, `${route.name}${i}`));
                }
                else {
                    if (!isLineAdded) {
                        isLineAdded = !isLineAdded;
                        return (_jsx("div", { className: "px-6 py-6", children: _jsx("hr", { style: {
                                    borderTop: `1px solid rgba(${hexToRgb(theme === null || theme === void 0 ? void 0 : theme.menuTextColor)}, 0.2)`,
                                } }) }, `${route.name}${i}`));
                    }
                    else {
                        return _jsx("div", {}, i);
                    }
                }
            })] }));
}
export default SidebarContent;
